import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { AdminCreateWalletTransactionRequest } from "@shopexperts/legacy-api";

interface CreateAdminWalletTransactionInput {
  organizationId: number;
  body: AdminCreateWalletTransactionRequest;
}

export function useCreateAdminWalletTransaction() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["admin", "wallet", "createTransaction"],
    mutationFn: async ({ organizationId, body }: CreateAdminWalletTransactionInput) => {
      return await api.admin.wallet.createOrganizationTransaction({
        params: { organization: organizationId },
        body,
      });
    },
    onSuccess: (_transaction, variables) => {
      toaster.create({ title: "Wallet transaction created successfully", type: "success" });
      queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "organization", variables.organizationId] });
      queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "organization", variables.organizationId, "level"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "organization", variables.organizationId, "transactions"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "transactions"] });
    },
    onError: (error: Error) => {
      toaster.create({ title: `Failed to create wallet transaction: ${error.message}`, type: "error" });
    },
  });
}
